import { StateSetter, useCallback } from 'react';
import { useLang } from 'hooks/lang';

import { Column, Row, IconButton, Button, Input } from 'components/Blocks';
import { PlusIcon, TrashIcon } from 'components/Icons';

import { FormTeamService } from './types';

interface ServiceTagsProps {
  service: FormTeamService | null;
  setService: StateSetter<FormTeamService | null>;
}

export function ServiceFileNames({ service, setService }: ServiceTagsProps) {
  const { t } = useLang();

  const addTag = useCallback(() => {
    setService((old) => ({
      ...old!,
      fileNames: [...(old?.fileNames || []), ''],
    }));
  }, [setService]);

  const removeName = useCallback(
    (index: number) => {
      setService((old) => ({
        ...old!,
        fileNames: (old?.fileNames || []).filter((_, i) => index !== i),
      }));
    },
    [setService],
  );

  const updateName = useCallback(
    (name: string, index: number) => {
      setService((old) => ({
        ...old!,
        fileNames: (old?.fileNames || []).map((existing, i) => (index === i ? name : existing)),
      }));
    },
    [setService],
  );

  return (
    <Column>
      <Row>
        <Column gap="1">
          <p className="flex items-center gap-2">
            {t('file-names')}

            <Button format="square" round onClick={addTag}>
              <PlusIcon size={16} />
            </Button>
          </p>

          <p className="text-sm">{t('service-file-names-explain')}</p>
        </Column>
      </Row>

      {service?.fileNames?.map((name, index) => (
        <Row key={index}>
          <span className="inline-block w-6">{index + 1}.</span>
          <Input value={name} onChangeDirect={(value) => updateName(value, index)} />

          <IconButton onClick={() => removeName(index)}>
            <TrashIcon size={12} />
          </IconButton>
        </Row>
      ))}
    </Column>
  );
}
